// Wording of the "Day submissions" walkthrough. Rules for every text: see ../help.js.
export default {
  title: "Day submissions",
  section: {
    DaySubmissionOverview: "Overview",
    DaySubmissionDetail: "Day submission",
    app: "In the app",
  },
  step: {
    intro: { text: "These are the days employees sent to the site management from the app." },
    filter: {
      text: "The chips filter by status, with Open preselected. The number in the navigation shows how many are still to be done.",
    },
    row: { text: "A row shows the day, the site and the sender. A click opens the day submission." },
    head: {
      text: "The site, working time and break as they were sent, and who sent the day. Without a site, you choose one when taking it over.",
    },
    origin: {
      text: "The map shows where the device was while recording, along with the sites nearby. Without a location, it says whether the app is still adding it.",
    },
    weather: {
      text: "The weather hour by hour. The three tagged hours go into the [[cr]]. Below is what the employee said about the weather.",
    },
    comments: { text: "The sender writes comments in the app, also later. They show up here." },
    entries: {
      text: "The other entries are in sections as in the report, as they were sent. Nothing can be changed here.",
    },
    readiness: {
      text: "This is where the day submission becomes a report, or you dismiss it. The report opens filled in the editor; you complete it and save.",
    },
    actions: { text: "Here the day submission becomes [[cr:a/an]] [[cr]] or [[hwr:a/an]] [[hwr]]. Or you dismiss it." },
    gap: { text: "What the report lacks is shown on the entry. You complete it in the report before saving it." },
    "app-record": {
      text: "In the app, employees tell their day instead of typing it. The app asks for what is still missing.",
    },
    "app-review": {
      text: "At the end they check the entries and send the day to the site management. Then it shows up here.",
    },
    "app-sent": { text: "The sender still sees sent days in the app. That is where they write their comments." },
    again: { text: "This button is on every page with a walkthrough. A click starts it again." },
  },
  image: {
    start: "The app's start page with the question about the day, site, start of work and microphone",
    listening: "The app while recording, with the next question and the entries recognised",
    review: "The entries to check with the Send to site manager button",
    check: "An unsure entry with what the app heard",
    sent: "A sent day in the app with its entries",
    sentComments: "The same day with the weather and a comment from the sender",
  },
}
